<template>
  <component :is="componentType" v-bind="componentProperties" :class="[className, {withThemeColors}]">
    <slot name="prepend" />
    <span>
      <template v-if="$slots.default">
        <slot />
      </template>
      <template v-else>
        {{ text }}
      </template>
    </span>
    <slot name="append" />
  </component>
</template>

<script setup lang="ts">
  const props = defineProps({
    type: {
      type: String as PropType<'button' | 'nuxt-link' | 'NuxtLink'>,
      default: 'button'
    },
    text: {
      type: String,
      default: '',
    },
    to: {
      type: [String, Object] as PropType<string | Record<string, any>>,
      default: '',
    },
    secondary: {
      type: Boolean,
      default: false,
    },
    negative: {
      type: Boolean,
      default: false,
    },
    medium: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
    external: {
      type: Boolean,
      default: false,
    },
    themeColors: {
      type: Boolean,
      default: false,
    },
    prevent: {
      type: Boolean,
      default: false,
    },
  });

  const router = useRouter()

  const componentProperties = computed(() => {
    return props.type === 'button' ? {} : {href: props.prevent ? router.resolve(props.to)?.href : props.to, target: props.external ? '_blank' : ''};
  });

  const withThemeColors = computed(() => props.themeColors);

  const componentType = computed(() => {
    if(props.prevent !== false) return 'a'
    return !props.to && props.type !== 'nuxt-link' && props.type !== 'NuxtLink' ? 'button' : defineNuxtLink({})
  });

  const className = computed(() => {
    let name = props.secondary ? `button--Secondary` : `button--Primary`;
    if (props.negative) name = `${name}Negative`;
    for (let prop of ['medium', 'small', 'fullWidth']) {
      if (props[prop]) name = `${name} ${prop}`;
    }
    return name;
  })
</script>